import { Paper, styled } from '@mui/material'

export const PaperComponent = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.grey['900'],
}))

export const DivComponent = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(1),
  marginLeft: theme.spacing(2),
  fontSize: 'small',
  fontStyle: 'italic',
}))
